import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FlightOutboundStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.89777 21.254C1.89777 20.8398 2.24239 20.504 2.66751 20.504H21.1412C21.5663 20.504 21.911 20.8398 21.911 21.254C21.911 21.6682 21.5663 22.004 21.1412 22.004H2.66751C2.24239 22.004 1.89777 21.6682 1.89777 21.254Z"
				fill="currentColor"
			/>
			<path
				d="M9.03367 1.92828C9.14425 1.9247 9.25498 1.94783 9.35542 1.9968L15.5185 5.00111L17.4537 4.48899L17.4707 4.48482L17.4886 4.48067C18.5585 4.25659 19.8363 4.44425 20.7242 4.93222L21.7742 5.49855L21.7891 5.50681L21.8041 5.51595C23.0868 6.2952 22.8446 8.17918 21.455 8.63763L21.4451 8.64103L21.4344 8.64441L16.7566 10.0225L11.8488 16.0766C11.7569 16.1899 11.6304 16.2714 11.4892 16.3081L8.68398 17.0361C8.43371 17.101 8.16827 17.0183 7.99815 16.8236C7.82803 16.6289 7.78218 16.3546 7.88009 16.1154L9.75323 11.5363L5.64987 12.0736C5.43082 12.1023 5.21143 12.0228 5.061 11.861L1.63292 8.17466C1.46774 7.99676 1.40912 7.74447 1.47941 7.51209C1.54984 7.2795 1.73912 7.10164 1.97553 7.04536L4.40909 6.46594L4.47958 6.45289C4.64436 6.43158 4.81214 6.47141 4.95092 6.56571L6.25879 7.45478L9.60208 6.56941L6.75297 3.42288C6.58775 3.24049 6.53299 2.98342 6.6103 2.74981C6.6878 2.51616 6.88519 2.3417 7.1267 2.2941L8.92405 1.94068L9.03367 1.92828ZM20.0709 6.13106C19.4851 5.80739 18.5442 5.65795 17.7785 5.81532L6.30838 8.85569C6.11704 8.90638 5.91328 8.87137 5.74958 8.76009L4.43204 7.86374L3.43093 8.10234L5.82088 10.6728L10.3067 10.0858L10.6072 9.45305L10.6776 9.33681C10.8641 9.08639 11.2041 8.98952 11.5005 9.12014C11.839 9.2695 11.9968 9.66155 11.8567 10.004L9.65996 15.3703L10.9285 15.0418L15.8308 8.99753L15.9024 8.92222C15.9782 8.85328 16.069 8.80207 16.1682 8.77277L21.0328 7.33814C21.3193 7.23891 21.3685 6.85739 21.1023 6.68818L20.0762 6.13471L20.0709 6.13106ZM8.57593 3.40079L11.0888 6.17524L13.4993 5.53673L8.96236 3.3245L8.57593 3.40079Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FlightOutboundStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FlightOutboundStrokeIcon;
